import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { FilterPeekItem } from '../../StyledComponents';
import axios from 'axios';
import { API_URLS } from '../../utility/api/endpoints/endpoints';

const PeekOtherCategories = (props) => {
  const { Peeks } = props;
  const [peekCategoriesData, setPeekCategoriesData] = useState([]);

  const fetchPeekCategories = async () => {
    const id =  props.categoryId

    try {
      const { data } = await axios.get(`${API_URLS.PEEK_CATEGORIES}/${id}`);
      setPeekCategoriesData(data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchPeekCategories();
  }, []);
  

  return (
    <div>
      <div style={{ backgroundColor: '#EC7426', color: 'white', padding: '8px 29px', display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        PEEK OTHER CATEGORIES
      </div>
      <div style={{ border: '1px solid #D9D9D9', borderBottom: '0px', marginBottom: '28px' }}>
        {
          peekCategoriesData && peekCategoriesData.length > 0 ? (
            peekCategoriesData.map((product, index) => (
              <div key={index} style={{ borderBottom: '1px solid #D9D9D9', display: 'flex', alignItems: 'center' }}>
                <Row style={{
                  width: '100%',
                  padding: '.2rem 1rem',
                  display: 'flex',
                  alignItems: 'center',
                }}>
                  <Col xl='3' lg='3' md='3' sm='3' className='p-0' style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={product.imageUrl === null ? 'https://placehold.co/400x515?text=No+Image': product.imageUrl} alt={product.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  </Col>
                  <Col xl='9' lg='9' md='9' sm='9'>
                    <FilterPeekItem>{product.name}</FilterPeekItem>
                  </Col>
                </Row>
              </div>
            ))
          ) : (
            <div style={{ padding: '20px', textAlign: 'center', color: '#EC7426' }}>
              No categories available
            </div>
          )
        }
      </div>
    </div>
  );
};

export default PeekOtherCategories;
